import { render, staticRenderFns } from "./OutOfStockOverview.vue?vue&type=template&id=5db073d4&scoped=true&"
import script from "./OutOfStockOverview.vue?vue&type=script&lang=js&"
export * from "./OutOfStockOverview.vue?vue&type=script&lang=js&"
import style0 from "./OutOfStockOverview.vue?vue&type=style&index=0&id=5db073d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db073d4",
  null
  
)

export default component.exports